




















import {Component, Mixins, Prop} from 'vue-property-decorator';
import InputMixin from '@/components/input/InputMixin';
import {Editor} from '@tiptap/vue-2';
import EditorMakeTableButton from '@/components/editor/toolbar-table-button/EditorMakeTableButton.vue';
import EditorTableToggleHeaderRow from '@/components/editor/toolbar-table-button/EditorTableToggleHeaderRow.vue';
import EditorTableAddColumnBefore from '@/components/editor/toolbar-table-button/EditorTableAddColumnBefore.vue';
import EditorTableAddColumnAfter from '@/components/editor/toolbar-table-button/EditorTableAddColumnAfter.vue';
import EditorTableDeleteColumn from '@/components/editor/toolbar-table-button/EditorTableDeleteColumn.vue';
import EditorTableAddRowBefore from '@/components/editor/toolbar-table-button/EditorTableAddRowBefore.vue';
import EditorTableAddRowAfter from '@/components/editor/toolbar-table-button/EditorTableAddRowAfter.vue';
import EditorTableDeleteRow from '@/components/editor/toolbar-table-button/EditorTableDeleteRow.vue';
import EditorTableMergeCell from '@/components/editor/toolbar-table-button/EditorTableMergeCell.vue';
import EditorTableSplitCell from '@/components/editor/toolbar-table-button/EditorTableSplitCell.vue';
import EditorTableDeleteTable from '@/components/editor/toolbar-table-button/EditorTableDeleteTable.vue';

@Component({
             components: {
               EditorTableDeleteTable,
               EditorTableSplitCell, EditorTableMergeCell, EditorTableDeleteRow, EditorTableAddRowAfter,
               EditorTableAddRowBefore, EditorTableDeleteColumn, EditorTableAddColumnAfter, EditorTableAddColumnBefore,
               EditorTableToggleHeaderRow, EditorMakeTableButton
             },
             mixins: [InputMixin]
           })
export default class TableToolbar extends Mixins<InputMixin>(InputMixin) {
  @Prop({default: null}) private editor: Editor;
}
